module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/chinese-medicine.json
// module id = 368
// module chunks = 125351562730620